import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearCompositions, getImposiumCompositions } from "reducers/ImposiumCompositions";
import { closeModal } from "reducers/Modal";

import BasicModal from "widgets/modals/BasicModal";

// import EmptySection from "widgets/EmptySection";
import {
	DataGrid,
	Button,
	ProgressIndicator
} from "rhombus-react";
import Measure from 'react-measure';

import {
	MIN_GRID_HEIGHT,
	DEFAULT_ROW_HEIGHT
} from 'utils/constants';

import { useGridScrollUtils } from "utils/DataGrid";
import StatusColumn from 'widgets/grid/cells/StatusColumn';


import "./CompositionsModal.css";


export function CompositionsModal(props){
	const dispatch = useDispatch();
	const { projectId, projectName } = props;

	const {
		libraryId,
		isLoading,
		compositions,
	} = useSelector((state) => {
		return {
			libraryId: state.libraryProperties.id,
			isLoading: state.imposiumCompositions.isLoading,
			compositions: state.imposiumCompositions.items,
		};
	});
	const dataGridRef = useGridScrollUtils([compositions]);

	// compositions can have multiple creatives.
	// if there are multiple creatives, we need a separate row for each
	// if there are no creatives, we still need a row for the composition
	const mappedCreatives = useMemo(() => {
		let comps = [];
		compositions.forEach((comp) => {
			if (comp.creatives?.length) {
				comps = comps.concat(comp.creatives.map((creative) => {
					return {
						compositionName: comp.name,
						compositionId: comp.id,
						creativeName: creative.name,
						creativeId: creative.id,
						creativeApproval: creative.approval,
					};
				}));
			} else {
				comps.push({
					compositionName: comp.name,
					compositionId: comp.id,
					creativeName: null,
					creativeId: null,
					creativeApproval: null,
				});
			}
		});
		return comps;
	}, [compositions]);

	useEffect(() => {
		dispatch(clearCompositions());
		dispatch(getImposiumCompositions(libraryId, projectId, projectName));
	}, []);

	function onClose(){
		dispatch(clearCompositions());
		dispatch(closeModal());
	}

	function renderContent(){
		const IMPOSIUM_COMPOSITION_COLUMNS = [
			{
				key: "compositionName",
				name: "Composition Name",
				sortable:false,
				resizable:false,
			},
			{
				key: "creativeName",
				name: "Creative Name",
				// width:165,
				sortable:false,
				resizable:false,
			},
			{
				key: "creativeId",
				name: "ID",
				width:80,
				sortable:false,
				resizable:false,
			},
			{
				key: "creativeApproval",
				name: "Status",
				width:150,
				sortable:false,
				resizable:false,
				getRowMetaData(data){
					return data;
				},
				formatter({ dependentValues }){
					if (dependentValues?.creativeId) {
						return <StatusColumn value={dependentValues?.creativeApproval || ""} />;
					}
					return null;
				},
			},
		];

		const dataGridProps = {
			columns: IMPOSIUM_COMPOSITION_COLUMNS,
			rowGetter:  rowId => mappedCreatives[rowId],
			rowsCount:  mappedCreatives.length,
			rowHeight:  DEFAULT_ROW_HEIGHT,
		};

		return (
			<div className="imposium-compositions-container">
				<ProgressIndicator isLoading={isLoading} />
				<div className="compositions-help-text">Compositions in this Imposium project</div>
				<div className="imposium-compositions">
					<Measure>
						{(obj) => {
							let gridHeight = obj?.contentRect?.entry?.height || MIN_GRID_HEIGHT;

							return (
								<div className="measure-component" ref={obj.measureRef}>
									<div ref={dataGridRef}>
										<DataGrid
											{...dataGridProps}
											minHeight={gridHeight}
										/>
									</div>
								</div>
							);
						}}
					</Measure>
				</div>
			</div>
		);
	}

	function renderFooter(){
		return ([
			<Button key="back" theme="default" onClick={onClose}>Close</Button>
		]);
	}

	const modalProps = {
		title: `Compositions - ${projectName}`,
		className: "imposium-compositions-modal",
		onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

CompositionsModal.displayName = "CompositionsModal";


export default CompositionsModal;
